import { createContext, useContext, useState } from "react";

const VoiceChatContext = createContext();

export const VoiceChatProvider = ({ children}) => {
    const [voiceSendMessage, setVoiceSendMessage] = useState("");
  return (
    <VoiceChatContext.Provider value={{ voiceSendMessage, setVoiceSendMessage }}>
      {children}
    </VoiceChatContext.Provider>
  );
};

export const useChat = () => useContext(VoiceChatContext);
